<template src="./user-notification.html">
</template>

<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import i18n from '@/i18n'
  import Datepicker from '@/utils/datepicker/'
  import { srCYRL, sr, en } from '@/utils/datepicker/locale'
  import Datatable from '@/components/misc/datatable/Datatable'
  import Moment from 'moment'
  import Loader from '@/components/misc/Loader'

  export default {
    name: 'user-notification',
    components: {
      Datatable,
      Datepicker,
      Loader
    },
    data () {
      return {
        dateFormat: this.$store.getters.dateFormat,
        dateLocale: srCYRL,
        load: false,
        NotificationStatus: {
          ACTIVE: 1,
          CANCELLED: 2
        },
        Priority: {
          LOW: 1,
          NORMAL: 2,
          HIGH: 3
        },
        notification: {},
        selectedNotification: [],
        selected: null,
        notificationsUrl: '',
        options: [
          {
            text: i18n.t('userAdministration.notificationPriorityStatus.1'),
            value: 1
          }, {
            text: i18n.t('userAdministration.notificationPriorityStatus.2'),
            value: 2
          }, {
            text: i18n.t('userAdministration.notificationPriorityStatus.3'),
            value: 3
          }
        ],
        tOptions: {
          checkboxes: false,
          payloadsTotalPropertyName: 'additionalInformation',
          invalidRowMarker: {
            criteria: function (row, statuses) {
              let validUntil = new Date(row['validUntil'])
              return row['status'] !== statuses.ACTIVE || validUntil < Date.now()
            },
            detailsLink: {
              createLink: function (row) {
                return null
              }
            }
          }
        },
        tColumns: [
          {
            columnName: 'creator',
            title: i18n.t('userAdministration.notificationCreator'),
            filterType: 'input',
            align: 'center',
            cell (row) {
              return row.creator
            }
          },
          {
            columnName: 'text',
            title: i18n.t('userAdministration.notificationText'),
            filterType: 'input',
            align: 'right',
            cell (row) {
              return row.text
            }
          },
          {
            columnName: 'created',
            columnRange: [
              {
                text: i18n.t('invoices.columnDueDateRangeFrom'),
                value: 'created-from'
              },
              {
                text: i18n.t('invoices.columnDueDateRangeTo'),
                value: 'created-to'
              }
            ],
            title: i18n.t('userAdministration.notificationCreatedDate'),
            filterType: 'date-range',
            hideFilter: true,
            align: 'center',
            cell (row) {
              return null
            }
          },
          {
            columnName: 'validUntil',
            columnRange: [
              {
                text: i18n.t('invoices.columnDueDateRangeFrom'),
                value: 'validUntil-from'
              },
              {
                text: i18n.t('invoices.columnDueDateRangeTo'),
                value: 'validUntil-to'
              }
            ],
            title: i18n.t('userAdministration.notificationValidUntil'),
            filterType: 'date-range',
            hideFilter: true,
            align: 'center',
            cell (row) {
              return null
            }
          },
          {
            columnName: 'priority',
            title: i18n.t('userAdministration.notificationPriority'),
            hideSort: true,
            filterType: 'select',
            filterSelectOptions: [
              { key: i18n.t('userAdministration.notificationPriorityStatus.0'), value: '' },
              { key: i18n.t('userAdministration.notificationPriorityStatus.1'), value: 1 },
              { key: i18n.t('userAdministration.notificationPriorityStatus.2'), value: 2 },
              { key: i18n.t('userAdministration.notificationPriorityStatus.3'), value: 3 }
            ],
            cell (row) {
              return null
            }
          }
        ]
      }
    },
    created () {
      this.notificationsUrl = Vue.$apiConfig.pagedNotificationsGet
      this.tOptions.statuses = this.NotificationStatus
    },
    mounted () {
      this.pushUrlToModel()
      this.pushModelToUrl()
      switch (this.$store.getters.dateLocale) {
        case 'sr-cyrl':
          this.dateLocale = srCYRL
          break
        case 'sr':
          this.dateLocale = sr
          break
        case 'en':
          this.dateLocale = en
          break
        default:
          this.dateLocale = srCYRL
      }
    },
    methods: {
      validateBeforeSubmit () {
        this.logConsole('Creating user notification')

        // validate first
        this.createNotification()
      },
      onRowSelected (row) {
        this.selectedNotification = row
        this.$refs.reviewNotificationModal.show()
      },
      createNotification () {
        this.load = true
        this.notification.status = this.NotificationStatus.ACTIVE
        this.$http.post(Vue.$apiConfig.userNotificationsCreatePost, this.notification)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.notificationCreated'),
              errors: []
            })
            EventBus.$emit('refresh-table')
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      updateNotification (cancelNotification) {
        this.load = true
        if (cancelNotification) { this.selectedNotification.status = this.NotificationStatus.CANCELLED }
        this.$http.post(Vue.$apiConfig.userNotificationsUpdatePost, this.selectedNotification)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.notificationUpdated'),
              errors: []
            })
            EventBus.$emit('refresh-table')
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      customFormatter (date) {
        Moment.locale(this.$store.getters.dateLocale)
        return Moment(date).format(this.dateFormat)
      },
      inputFormat (date) {
        Moment.locale(this.$store.getters.dateLocale)
        return Moment(date, this.dateFormat).valueOf()
      }
    }
  }
</script>
<style lang="scss" type="text/scss" scoped>

  .container {
    padding: 0px;
  }

  @media (min-width: 1400px) {
      .container {
          width: 1360px;
          max-width: 100%;
      }
  }

  @media (min-width: 1680px) {
      .container {
          width: 1640px;
          max-width: 100%;
      }
  }

  @media (min-width: 1920px) {
      .container {
          width: 1860px;
          max-width: 100%;
      }
  }

  @media (min-width: 2560px) {
      .container {
          width: 2460px;
          max-width: 100%;
      }
  }

  @media (min-width: 2880px) {
      .container {
          width: 2620px;
          max-width: 100%;
      }
  }

  @media (min-width: 3840px) {
      .container {
          width: 3550px;
          max-width: 100%;
      }
  }    
  
  .invalid-notification {
    background-color: #f8d7da !important;
  }
  
</style>



// WEBPACK FOOTER //
// UserNotification.vue?25a48a7c